var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"info"}},[(_vm.show)?_c('img',{attrs:{"src":require("../../assets/info-h.jpg"),"alt":""}}):_c('img',{attrs:{"src":require("../../assets/info-v.jpg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }